import { featureFlags } from '@/config/featureFlags'
import {
  FeatureFlag,
  FeatureFlagsContext,
} from '@/shared/contexts/featureFlagsContext'
import { ReactNode } from 'react'

type FeatureFlagsProviderProps = {
  children: ReactNode
  overrideFeatureFlags?: FeatureFlag[]
}

export const FeatureFlagsProvider = ({
  children,
  overrideFeatureFlags,
}: FeatureFlagsProviderProps) => {
  const flagsToUse = overrideFeatureFlags || featureFlags

  return (
    <FeatureFlagsContext.Provider value={{ featureFlags: flagsToUse }}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
